import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useToaster } from "@insite/mobius/Toast/ToasterContext";
import OrderHistoryProductSelector, {
    OrderHistoryProductSelectorStyles,
} from "@store/Components/Rma/OrderHistoryProductSelector";
import addProduct from "@store/Store/Pages/Rma/Handlers/AddProduct";
import { OrderHistoryProductModel } from "@store/Types/ApiModels";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import { v4 as uuidv4 } from "uuid";

const mapDispatchToProps = {
    addProduct,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderHistorySearchStyles {
    orderHistoryOrderHistoryProductSelector?: OrderHistoryProductSelectorStyles;
}

export const orderHistorySearchStyles: OrderHistorySearchStyles = {
    orderHistoryOrderHistoryProductSelector: {
        container: {
            css: css`
                width: 100%;
            `,
        },
        buttonGridItem: {
            css: css`
                justify-content: flex-end;
            `,
        },
    },
};

const styles = orderHistorySearchStyles;

const OrderHistorySearch = ({ addProduct }: Props) => {
    const toasterCtx = useToaster();

    const addProductToOrder = (product: OrderHistoryProductModel) => {
        const productToAdd = { ...product, lineId: uuidv4() };
        addProduct({ selectedProduct: productToAdd });
        toasterCtx.addToast({ body: translate("Item Added"), messageType: "success" });
    };

    return (
        <OrderHistoryProductSelector
            selectButtonTitle={translate("Add to Returns List")}
            onSelectProduct={addProductToOrder}
            onAddNewProduct={addProductToOrder}
            productIsConfigurableMessage={siteMessage("QuickOrder_CannotOrderConfigurable")}
            productIsUnavailableMessage={siteMessage("QuickOrder_ProductIsUnavailable")}
            extendedStyles={styles.orderHistoryOrderHistoryProductSelector}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(OrderHistorySearch),
    definition: {
        group: "RMA" as any,
    },
};

export default widgetModule;
